import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;

  [prop: string]: unknown;
}

export default ({ style, ...rest }: IProps) => {
  const defaultStyle = { width: 18, height: 18 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height} {...rest}
         viewBox="0 0 18 18" fill="none">
      <path
        d="M12.1622 8.7002C12.7459 8.7002 13.3297 9 13.6216 9.5C13.9135 10.1 14.1081 10.8 14.1081 11.5V18H18V11C18 10.2 17.9028 9.4001 17.7082 8.6001C17.5136 8.0001 17.2217 7.3999 16.7352 6.8999C15.9568 5.9999 14.7892 5.5001 13.5243 5.6001C12.746 5.6001 11.8703 5.7998 11.1892 6.2998C10.7027 6.6998 10.3136 7.1001 10.0217 7.6001V5.8999H6.12978C6.22707 6.9999 6.12978 17.9 6.12978 18H10.0217V11.2002C10.0217 10.9002 10.0216 10.5002 10.1189 10.2002C10.3135 9.8002 10.5081 9.5002 10.8 9.2002C11.2865 8.9002 11.6757 8.7002 12.1622 8.7002ZM0.194666 5.7998V17.8999H4.08656V5.7998H0.194666ZM2.14061 0C1.55683 0 0.972949 0.200098 0.58376 0.600098C0.194571 1.0001 0 1.5001 0 2.1001C0 2.7001 0.194571 3.2001 0.58376 3.6001C0.972949 4.0001 1.55683 4.2002 2.14061 4.2002C2.7244 4.2002 3.30813 4.0001 3.79462 3.6001C4.18381 3.2001 4.37838 2.7001 4.37838 2.1001C4.37838 1.5001 4.18381 1.0001 3.79462 0.600098C3.30813 0.200098 2.7244 0 2.14061 0Z"
        fill="#88888A" />
    </svg>
  );
};
